<template>
    <div>
        <label
            v-if="$slots.default"
            :for="'select-input-' + key"
            class="block cursor-default mb-8 text-body-sm first-letter:uppercase"
            @click="focusInput"
        >
            <slot></slot>
        </label>
        <div
            class="w-full p-8 border rounded-sm flex gap-8 flex-wrap cursor-text"
            :class="[{'ring-2 ring-primary-60': isFocused}, height, error ? 'border-semantic-error' : 'border-primary-20']"
            @click="focusInput"
        >
            <div v-if="icon" class="px-8">
                <svg-icon
                    :class="iconColor"
                    :type="icon"
                    class="max-w-16 max-h-16"
                />
            </div>
            <div
                v-for="(value, index) in inputValue"
                :key="'option-' + key + '-' + index"
                class="bg-primary h-full text-white font-semibold rounded-sm space-x-8 px-6 py-2 flex items-center justify-between"
            >
                <span>{{ value }}</span>
                <button @click="removeValue(value)">
                    <svg-icon type="cancel" class="w-16 h-16" />
                </button>
            </div>
            <input
                :id="'select-input-' + key"
                ref="select-input"
                type="text"
                class="outline-none placeholder-primary-80 grow"
                v-model="userValue"
                @keydown.enter="addValue"
                @keydown.backspace="removeValue(null)"
                @keydown.esc="clearInput"
                @focusout="isFocused = false"
                :placeholder="placeholderString"
            >
        </div>
        <p v-if="error" class="text-semantic-error text-body-sm">{{ error }}</p>
    </div>
</template>
<script>
import SvgIcon from "../ui/SvgIcon.vue";
import uniqueId from 'lodash/uniqueId';

export default {
    name: "SelectInput",
    components: {SvgIcon},
    props: {
        value: {
            default: () => [],
        },
        placeholder: String,
        height: {
            type: String,
            default: 'min-h-42'
        },
        icon: String,
        iconColor: String,
        errors: Array,
    },
    data() {
        return {
            key: uniqueId('option'),
            userValue: '',
            isFocused: false,
        }
    },
    computed: {
        inputValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        placeholderString() {
            return this.placeholder || this.$t('general.create_tag');
        },
        error() {
            if (!this.errors) {
                return null;
            }

            return Array.isArray(this.errors) ? this.errors[0] : this.errors;
        },
    },
    methods: {
        focusInput() {
            this.$refs['select-input'].focus();
            this.isFocused = true;
        },
        removeValue(value) {
            if (!!value) {
                this.inputValue = this.inputValue.filter(x => x !== value);
            } else if (!this.userValue && this.inputValue.length > 0) {
                this.inputValue = this.inputValue.slice(0, -1);
            }
        },
        addValue() {
            if (this.userValue && !this.inputValue.includes(this.userValue)) {
                this.inputValue.push(this.userValue);
            }
            this.userValue = '';
        },
        clearInput() {
            this.userValue = '';
        }

    }
}
</script>
<style scoped>

</style>